module.exports = __webpack_public_path__ + "static/media/ePharmacie_eSIGL_and_GS1_data_flows_Slide6_English.0f23d68c.jpg";